import { Messenger } from './Messenger';

export enum ComponentTypes {
  PageScroll = 'PAGE_SCROLL',
  MainNav = 'MAIN_NAV',
  Marquee = 'Marquee',
  Live = 'Live',
  Poster = 'Poster',
  Featured = 'Featured',
  Standard = 'Standard',
  ExtrasLogos = 'ExtrasLogos',
  BackToTopButton = 'BackToTopButton',
  MyShows = 'MyShows',
}
export type ComponentTypesUnion =
  | 'PAGE_SCROLL'
  | 'MAIN_NAV'
  | 'Marquee'
  | 'Live'
  | 'Poster'
  | 'Featured'
  | 'Standard'
  | 'ExtrasLogos'
  | 'MyShows'
  | 'BackToTopButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ListenerData<T = any> = {
  messenger: Messenger<T>;
  receiver: number | ((data: T) => void);
};
